import * as React from 'react';
import { CONTAINER_NUMBERS_RE } from 'services/helpers/containers';
import { GenericSearch } from './GenericSeach';

interface Props {
  onSearch: (containerNumbers: string[]) => void;
  setContainerNumbers?: (containerNumbers: string[]) => void;
  containerNumbers: string[];
}

/**
 * Renders an input for searching through the available containers
 * @returns
 */
export const ContainerSearch: React.FC<Props> = (props) => {
  const { onSearch, containerNumbers, setContainerNumbers } = props;
  return (
    <GenericSearch
      onSearch={onSearch}
      setContainerNumbers={setContainerNumbers}
      inputValues={containerNumbers}
      maximum={100}
      checkIsValid={(value: string) => {
        return CONTAINER_NUMBERS_RE.test(value);
      }}
      placeholder="Filter by container number"
      variant="rounded"
      includeInvalid
    />
  );
};
ContainerSearch.displayName = 'ContainerSearch';
